import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
// -------------------------------------
import {register} from 'ol/proj/proj4';
import proj4 from 'proj4';
// -------------------------------------
import XYZ from 'ol/source/XYZ';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorSource from 'ol/source/Vector.js';
// -------------------------------------

// Styling
import Circle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Icon from 'ol/style/Icon.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import Text from 'ol/style/Text.js';
// -------------------------------------

import Overlay from 'ol/Overlay.js';   // popup
// -------------------------------------
import MousePosition from 'ol/control/MousePosition.js';
import {toStringXY} from 'ol/coordinate.js'
import {Attribution} from 'ol/control';
// -------------------------------------
import  Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition.js';
// ----------------------------------------
import {defaults as defaultControls} from 'ol/control.js';


// Projection
// ----------
proj4.defs("EPSG:2100","+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-199.87,74.79,246.62,0,0,0,0 +units=m +no_defs +type=crs");
register(proj4);





// ======== MAP CONTROLS =========
// -------------------------------

// Mouse Position
const mousePos = new MousePosition({
  className: 'mousePosition',
  coordinateFormat: function(coordinate){
      return toStringXY(coordinate, 2); 
  }
});

// Attribution
// -----------
const attribution = new Attribution({
  collapsible: true,
})



// Elements of the popup.
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

//
const infoContainer = document.getElementById('info-table');
//

// Create an overlay to anchor the popup to the map
const overlay = new Overlay({
  element: container,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
  positioning: "bottom-center"
});


 // A click handler to hide the popup.
closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  return false;   // Don't follow the href.
};


// ========================================



const labelPolyFeatures = function(feature){
  let name = feature.get('OT');
  const styles = [
    new Style({
        fill: new Fill({
          color: [255,255,255,0.4]
        }),
        stroke: new Stroke({
          color: '#595bbc',
          width: 1.25
        }),
        text: new Text({
          text: name,
          fill: new Fill({
          color: [232,26,26,1]
        }),
        stroke: new Stroke({
           color: [232,26,26,1],
           width: 0.3
        })
  })
    })

  ];

  return styles;
}

const labelLineFeatures = function(feature){
  let name = feature.get('Mik');
  const styles = [
    new Style({
        stroke: new Stroke({
      color: '#0bb68e',
      width: 2.5
    }),
        text: new Text({
          text: name,
          placement: 'line',
          textBaseline: 'bottom',
          font: 'bold 12px Arial, sans-serif',
          // scale: 1.2,
          fill: new Fill({
          color: '#000',
          stroke: new Stroke({color: '#4a4a4a', width:3})
        }),
        
  })
    })

  ];

  return styles;
}




const pointStyle = new Style({
  image: new Circle({
    radius: 0.5,
    fill: new Fill({
      color: '#cc443d',
    }),
    stroke: new Stroke({
      color: 'white',
      width: .2,
    }),
  }),
});



//  ============= Data Layers =============
//  =======================================

// Open Street Maps
const osm = new TileLayer({
  name: 'OSM',
  title: 'Open Street Maps',
  source: new OSM(),
  //minResolution: 3,
  //maxResolution: 500,
  maxZoom: 15
  // visible: false,
});


// Esri World Imagery
const satImage = new TileLayer({
  name: 'SatImage',
  title: 'Satellite Image',
  //type: 'base',
  source: new XYZ({
    // Example using Esri World Imagery
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    maxZoom: 19,
    attributions: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  }),
  // minResolution: 500,
  // maxResolution: 1500,
  minResolution: 5,
  visible: false,
});





// Vector Layers
// -------------
const komotini = new VectorLayer({
    name: 'Komotini',
    title: 'ΒΙ.ΠΕ Κομοτηνής',
    type: 'bipe',
    center: [626000, 4547280],
    source: new VectorSource({
        url: './data/komotini.geojson',
        format: new GeoJSON(),
  }),
  style:labelPolyFeatures
})

const ioannina = new VectorLayer({
    name: 'Ioannina',
    title: 'ΒΙ.ΠΕ Ιωαννίνων',
    type: 'bipe',
    center: [222000,4400000],
    source: new VectorSource({
        url: './data/ioannina.geojson',
        format: new GeoJSON(),
  }),
  style: labelPolyFeatures
})

const ioannina_mik = new VectorLayer({
  name: 'Ioannina_Mik',
  title: 'Ιωάννινα Μηκοτομές',
  type: 'mik',
  source: new VectorSource({
        url: './data/ioannina_mik.geojson',
        format: new GeoJSON(),
  }),
  style: labelLineFeatures
  // style: new Style({
  //   stroke: new Stroke({
  //     color: '#d343f1',
  //     width: 2.5
  //   })
  // })

})


const ot3 = new VectorLayer({
  name: 'OT3',
  title: 'ΟΤ3: Συντεταγμένες',
  type: 'coords',
  source: new VectorSource({
    url: './data/coord/OT3coord.geojson',
    format: new GeoJSON(),
  }),
  style: pointStyle,
  // visible: false

})


// test 
const gr_cities = new VectorLayer({
  name: 'Cities',
  title: 'Πρωτεύουσες Νομών',
  type: '',
  source: new VectorSource({
    url: './data/gr_cities.geojson',
    format: new GeoJSON(),
  }),
  style: pointStyle,

})
// test 



// // tesing ... bipe site center points
// const bipe = {x:430000, y:4250000};
// const tripoli = {x: 359500, y: 4152500};


// function zoomToLayerExtent(layer){
//           mapView.animate({center: [layer.x, layer.y], zoom: 4})
// }
// // ---------------------------------




//  =======================================
//  =======================================


const map = new Map({
  target: 'map',
  // controls: [mousePos],
  controls: defaultControls({attribution: false}).extend([
    mousePos,
  ]),
  layers: [
    satImage,osm,
    komotini,ioannina,
    ioannina_mik,
    ot3,
    // gr_cities
  ],
  view: new View({
    center: [430000, 4250000],
    extent: [-421800, 3820000, 1240000, 4640000],
    zoom: 4,      //15 regular zoom to BI.PE
    minZoom: 2,
    // maxZoom: 16,
    projection: 'EPSG:2100'
  }),
  overlays: [overlay]
});



// Select features
// ---------------
const navElements = document.querySelector('.column-navigation');
// const cityNameElement = document.getElementById('cityname');
// const cityImageElement = document.getElementById('cityimage');
const mapView = map.getView();

// const btnImage = document.getElementById('popup-action-btn');
const btnImage = document.createElement('button');
btnImage.className = 'popup-action-btn';
btnImage.innerHTML = 'Download';

const a = document.createElement("a");

btnImage.addEventListener('click', ()=>{
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
});

const title = document.getElementById('popup-title');





map.on('singleclick', function(evt){

  // remove popover-information overlay
  popoverTextLayer.setPosition(undefined);

  // console.log(evt.coordinate);
  overlay.setPosition(undefined);
  map.forEachFeatureAtPixel(evt.pixel, function(feature, layer){
    // Clear the popup content
    content.innerHTML = '';
    

    const lType = layer.get('type');

    if (lType === 'mik'){


        const feat = feature.get('Mik');
        const infoImage = document.createElement("IMG");
        

        
        title.innerHTML = `Μηκοτομή: ${feat}`;

        infoImage.setAttribute('src', './data/m/' + feat + '.png');
        infoImage.setAttribute('style', 'width:800px; height:350px;');
        
        // Image download
        a.href = `${infoImage.src}`;
        a.download = `${feat}.png`;


        // adjust the popup dimensions
        let popClass = document.querySelector('.ol-popup');
        popClass.setAttribute('style', 'width: 800px; height: 480px;');
        
        content.append(title);
        content.append(infoImage);
        content.append(btnImage);


    } else if (lType === 'bipe') {        
        const feat = feature.get('OT');


        console.log(feat);

        // info table
        const infoTable = document.createElement('table');
        title.innerHTML = `Όροι Δόμησης (${feat})`;
        
        let featureAtPixel = map.getFeaturesAtPixel(evt.pixel);
        const layerFeatures = featureAtPixel[0].getKeys();




          const coordTable = document.createElement('table');   //test
          const coordInfo = document.createElement('button');
          coordInfo.className = 'coordinates';
          const coordinateContainer = document.createElement('div');
          coordinateContainer.className = 'coord-container';




          
          map.getLayers().forEach(function(layer){
                  // if (layer.get('name') === 'Parcel Coords'){
                  if (layer.get('name') === feat){

                    const feats = layer.getSource().getFeatures();
                    //console.log(feats[0].getKeys()[1]);

                    for(let i = 0; i < feats.length; i++){
                          // console.log(`${feat.get('id')} - ${feat.get('x')} - ${feat.get('y')}`);
                          const tr = document.createElement('tr');
                          const td1 = document.createElement('th');
                          td1.style.textAlign = 'left';
                          const td2 = document.createElement('th');
                          td2.style.textAlign = 'left';
                          const td3 = document.createElement('th');
                          td3.style.textAlign = 'left';

                          td1.innerHTML = feats[i].get('id');
                          td2.innerHTML = feats[i].get('x');
                          td3.innerHTML = feats[i].get('y');
                          tr.append(td1);
                          tr.append(td2);
                          tr.append(td3);
                      
                          coordTable.append(tr);

                    }
                    
                      
                  
                  }
               });


          coordinateContainer.append(coordTable);

          coordInfo.addEventListener('click', function(){
                coordinateContainer.classList.toggle('open');
          });
          




        // Add data to table
        for (let i = 0; i < layerFeatures.length; i++){
            //console.log(layerFeatures[i] + ":" + featureAtPixel[0].get(layerFeatures[i]));

            const tr = document.createElement('tr');
            const td1 = document.createElement('th');
            td1.style.textAlign = 'left';
            const td2 = document.createElement('th');
            td2.style.textAlign = 'left';

            td1.innerHTML = layerFeatures[i];
            td2.innerHTML = featureAtPixel[0].get(layerFeatures[i]);


          coordInfo.innerHTML = 'Συντεταγμένες';


          

            tr.append(td1);
            tr.append(td2);
            infoTable.append(tr);
        }

        // adjust the popup dimensions
        container.style.width = '400px';
        container.style.height = '500px';

        content.append(title);
        content.append(infoTable);
//test
        content.append(coordInfo);
        // content.append(coordTable)
        content.append(coordinateContainer);
    } 

    // set popup position
    const coordinate = evt.coordinate;   
    overlay.setPosition(coordinate);


  })
});



// Navigation Button Logic
// -----------------------
const anchorNavElements = document.querySelectorAll('.column-navigation > a');



for(let anchorNavElement of anchorNavElements){
    anchorNavElement.addEventListener('click', function(e){
       let clickedAnchorElement = e.currentTarget;
       let clickedAnchorElementID = clickedAnchorElement.id;
       mainLogic(clickedAnchorElement);
    })
}




function mainLogic(clickedAnchorElement){

    // console.log(clickedAnchorElement);
    // Re-assign active class to the clicked element
    let currentActiveStyledElement = document.querySelector('.active');
    console.log(currentActiveStyledElement);

    let clickedAnchorElementID = clickedAnchorElement.id;


    currentActiveStyledElement.className = currentActiveStyledElement.className.replace('active', '');
    clickedAnchorElement.className = 'active';

    // Change the view based on the layer
    if(clickedAnchorElementID == 'home'){
          zoomToMapExtent();
    }
    map.getLayers().forEach(function(layer){
          if (layer.get('name') === clickedAnchorElementID){
            //  console.log(clickedAnchorElement.className);
             // Zoom the Layer's extent
             let lyrCenter = layer.get('center');
             mapView.animate({zoom: 8}, {center: lyrCenter}, {zoom: 15})        


          } 
    })

}



function zoomToMapExtent(){
          mapView.animate({center: [430000, 4250000], zoom: 4})
}



// Selected Features - Styling
// ---------------------------
const selectInteraction = new Select({
  condition: click,
  style: new Style({
      fill: new Fill({
          color: 'rgba(255,255,0,0.4)'
      }),
      stroke: new Stroke({
          color:'rgba(255,165,0,1)',
          width:5
      })
  })
});

map.addInteraction(selectInteraction);


 


// // Slider
// // ------
// const slider = document.getElementById('dateSlider');
// const label = document.getElementById('dateLabel');

// slider.addEventListener('input', (event) =>{
//   const stepValue = Number(event.target.value);
//   //const targetDate = getDateFromStep(stepValue);
//   label.textContent = slider.value;
//   const lyrs = map.getLayers().getArray();
//   for (let i = 0; i < lyrs.length; i++){

//       if (lyrs[i].getProperties().name === 'Cities'){
//          console.log(lyrs[i].getSource().getFeatureById('name'));
//       } else {
//          console.log('Other layer');
//       }
//   }
// })


// Popover Information 
// -------------------
const popoverTextElement = document.getElementById('popover-text');
const popoverTextLayer = new Overlay({
    element: popoverTextElement,
    positioning: 'bottom-center',
    stopEvent: false
});
map.addOverlay(popoverTextLayer);
map.on('pointermove', function(evt){
  let isFeatureAtPixel = map.hasFeatureAtPixel(evt.pixel);
    if (isFeatureAtPixel){

       map.forEachFeatureAtPixel(evt.pixel, function(feature, layer){
          if (layer.get('type') === 'bipe'){
              let featureAtPixel = map.getFeaturesAtPixel(evt.pixel);
              let featureName = featureAtPixel[0].get('XRHSH');
              if (featureName){
                  popoverTextLayer.setPosition(evt.coordinate);
                  popoverTextElement.innerHTML = featureName; 
              }
          } 
       })  
    } else {
          popoverTextLayer.setPosition(undefined);
    }
});






map.on('click', function(e){
  console.log(e.coordinate);
});


// [64368, 3829868, 893428, 4618185]